import {BaseFormModel} from './base-form-model';
import {MenuItemTopping} from './menu-item-topping';
import {OrderItemToppingModifier} from './order-item-topping-modifier';
import {groupAndSortModifiers} from '../_utils/sortable-utils';

export class OrderItemTopping extends BaseFormModel<OrderItemTopping> {
    id: number;
    included: boolean;
    name: string;
    menuItemTopping: MenuItemTopping;
    modifiers: OrderItemToppingModifier[];
    groupedModifiers = [];
    additionalPrice: number;
    computedPrice: number;
    containsModifiers: boolean;

    public constructor(jsonInput: any) {
        super(jsonInput);
        Object.assign(this, jsonInput);
        this.menuItemTopping = !!this.menuItemTopping ? new MenuItemTopping(this.menuItemTopping) : null;
        const modifiers = [];
        if (this.modifiers) {
            this.modifiers.forEach(sel => {
                modifiers.push(new OrderItemToppingModifier(sel));
            });
        }
        this.modifiers = modifiers;
        this.init();
    }

    init(): void {
        this.menuItemTopping = new MenuItemTopping(this.menuItemTopping);
        if (!this.modifiers) {
            this.modifiers = [];
        }

        this.groupedModifiers = groupAndSortModifiers(this.modifiers);

        this.containsModifiers = this.menuItemTopping && this.menuItemTopping.topping &&
            (this.menuItemTopping.topping.modifiers.length > 0
                || this.menuItemTopping.topping.modifierSelections.length > 0
                || this.menuItemTopping.topping.modifierGroups.length > 0
            );
    }
}
